import { RestApiClient, TAG_USER_ROLE_ID } from 'ifield-core-components'
import _ from 'lodash'

/**
 * ユーザー取得
 * @returns {Array.<Object>|Object} データ
 */
const getUsers = async () => {
  const url = RestApiClient.createApiUrl('user')
  url.searchParams.append('all', true)
  const json = await RestApiClient.executeGetApi(url)
  return json.data
}

/**
 * 初期スロットル間隔(ms)
 */
const INITIAL_THROTTLE_TIME = 30000

const getDefaultState = () => ({
  users: [],
  throttleTime: INITIAL_THROTTLE_TIME,
  throttler: null,
})

export default {
  namespaced: true,
  state: getDefaultState(),
  persistentStates: ['throttleTime'],
  mutations: {
    /**
     * stateを初期化する
     * @param {*} state
     */
    resetState(state) {
      Object.assign(state, getDefaultState())
    },
    /**
     * ユーザーを設定する
     * @param {*} state
     * @param {Array.<Object>} users ユーザー
     */
    setUsers(state, users) {
      state.users = users
    },
    /**
     * スロットル間隔を保存する
     * @param {*} state
     * @param {Number} time スロットル間隔(ms)
     */
    setThrottleTime(state, time) {
      state.throttleTime = +time
    },
    /**
     * スロットル関数を保存する
     * @param {*} state
     * @param {Function} throttler スロットル関数
     */
    setThrottler(state, throttler) {
      state.throttler = throttler
    },
  },
  getters: {
    /**
     * ユーザー
     * @param {*} state
     * @returns {Array.<Object>}
     */
    users: (state) => {
      return state.users
    },
    /**
     * ユーザーMap
     * @param {*} state
     * @returns {Map.<Number, Object>}
     */
    userMap: (state) => new Map(state.users.map((user) => [user.id, user])),
    /**
     * ユーザーMapから指定IDデータを取得
     * @param {*} state
     * @param {*} getters
     * @returns {Object}
     */
    getUserById: (state, getters) => (id) => getters.userMap.get(id),
    /**
     * タグロールのユーザーが存在するか
     * @param {*} state
     * @returns {Boolean}
     */
    hasTagUser: (state) => {
      return state.users.some((user) => user.role_id === TAG_USER_ROLE_ID)
    },
  },
  actions: {
    /**
     * stateをリセットする
     */
    resetState({ commit }) {
      commit('resetState')
    },
    /**
     * Userを更新する
     */
    async updateUsers({ commit }) {
      const users = await getUsers()
      commit('setUsers', users)
    },
    /**
     * ユーザーを更新する(スロットル)
     */
    async updateUsersWithThrottle({ state, commit, dispatch }) {
      if (!state.throttler) {
        const throttler = _.throttle(
          () => dispatch('updateUsers'),
          state.throttleTime,
          { trailing: false }
        )
        commit('setThrottler', throttler)
      }
      return state.throttler()
    },
    /**
     * スロットル間隔更新
     * @param {Number} time スロットル間隔(ms)
     */
    updateThrottleTime({ commit }, time) {
      commit('setThrottleTime', +time)
      commit('setThrottler', null)
    },
  },
}
